import { faPalette, faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons';
import { CustomerPageContainer } from '@/components/customer-portal/CustomerPageContainer';
import { CustomerPageHeader } from '@/components/customer-portal/CustomerPageHeader';
import { CustomerSectionCard } from '@/components/customer-portal/CustomerSectionCard';
import { CustomerThemePicker } from '@/components/customer-portal/CustomerThemePicker';
import { CustomerThemeToggle } from '@/components/customer-portal/CustomerThemeToggle';
import { CUSTOMER_SKIN_META, useCustomerTheme } from '@/providers/CustomerThemeProvider';

/**
 * D-130 rule 6 — Appearance.
 *
 * Two independent controls: the theme (six named skins, Forge default) and the
 * mode (light / dark / system). Both are presentation-only and stored per
 * device in localStorage — no backend column, no API call, no effect on
 * authorization, location scope, data, workflow or available actions.
 */
export function CustomerAppearancePage() {
  const { skin, mode } = useCustomerTheme();
  const activeName = CUSTOMER_SKIN_META[skin].name;
  const modeLabel = mode === 'system' ? 'Match device' : mode === 'dark' ? 'Dark' : 'Light';

  return (
    <CustomerPageContainer>
      <CustomerPageHeader
        title="Appearance"
        subtitle="Choose how your portal looks. This changes visual style only — your data, permissions and actions stay exactly the same."
      />

      <div className="space-y-4">
        <CustomerSectionCard
          title="Theme"
          icon={faPalette}
          description={`${activeName} is currently applied.`}
        >
          <CustomerThemePicker />
        </CustomerSectionCard>

        <CustomerSectionCard
          title="Light & dark"
          icon={faCircleHalfStroke}
          description={`${modeLabel} is currently applied. This works with every theme.`}
        >
          <div className="flex flex-wrap items-center gap-3">
            <CustomerThemeToggle />
            <p className="min-w-0 flex-1 break-words text-xs text-customer-text-secondary">
              Match device follows your system setting and changes automatically.
            </p>
          </div>
        </CustomerSectionCard>
      </div>

      <p className="mt-4 text-xs leading-relaxed text-customer-text-secondary">
        Your choice is saved on this device only. Signing in on another device or browser starts
        again from the default theme.
      </p>
    </CustomerPageContainer>
  );
}
